export const getQueryString = (
  params: Record<string, string | number | boolean>
): string =>
  Object.keys(params).reduce(
    (acc, key, index) =>
      `${acc}${index === 0 ? '?' : '&'}${key}=${params[key]}`,
    ''
  )
